module.exports = __webpack_public_path__ + "media/images/florence-dcb6c1a0124e9dc509cee68f1700eb54.png";